import React, { Component } from "react";
import { PostData } from "../../../../service/postData";
import { sendNotification } from "../../../../_notificationSettings/notificationPanel";
import { MDBDataTableV5 } from "mdbreact";
import { numberFormat } from "../../../../config/numberFormat";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { Link } from 'react-router-dom';
import moment from "moment";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import * as XLSX from "xlsx";
import * as FileSaver from 'file-saver';

import DownloadBtnSaleInvoicePdf from "../../Invoices/Sale/DownloadBtnSaleInvoicePdf";
import PrintBtnSaleInvoicePdf from "../../Invoices/Sale/PrintBtnSaleInvoicePdf";
import DownloadBtnSaleReturnInvoicePdf from "../../Invoices/SaleReturn/DownloadBtnSaleReturnInvoicePdf";
import PrintBtnSaleReturnInvoicePdf from "../../Invoices/SaleReturn/PrintBtnSaleReturnInvoicePdf";

let _UserSession = localStorage.getItem("vs_UserSession");
let _signingId = "0";
let _businessId = "0";
let _companyId = "0";

if (_UserSession!=undefined || _UserSession!=null) { 
  _UserSession = JSON.parse(_UserSession);
  _signingId = _UserSession.loginId;
  _businessId = _UserSession.tokenKey;
}

let _companySession = localStorage.getItem("vs_UserCompanySession");
if (_companySession!=undefined || _companySession!=null) {
  _companySession = JSON.parse(_companySession);
  _businessId = _companySession.business_id;
  _companyId = _companySession.company_id;
}

let columns = [
  {
    label: "#",
    field: "sr_no",
    width: 100,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "#",
    }, 
  },
  {
    label: "Date",
    field: "date",
    width: 150,
    attributes: {
      "aria-controls": "DataTable", 
      "aria-label": "Date",
    },
  },
  {
    label: "Type",
    field: "type",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Type",
    },
  },
  {
    label: "Amount",
    field: "amount",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Amount",
    },
  },
  {
    label: "Ending Balance",
    field: "ending_balance",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Ending Balance",
    },
  },
];

let _loader = "glb-ldr-prt active";
let _currentYear = moment().format("YYYY");
let _startDateYaer = "01/01/" + _currentYear;
let _endDateYaer = "12/31/" + _currentYear;
export default class dayBookReportPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: true,
      transactionArray: [],
      transactionArrayFilter: [],
      activeTransactionKey: "ALL",
      businessId: _businessId,
      company_id: _companyId,
      userId: _signingId,
      name: null,

      paidAmount: 0,
      unpaidAmount: 0,
      total: 0,

      startDate: moment(_startDateYaer).format("YYYY-MM-DD"),
      endDate: moment(_endDateYaer).format("YYYY-MM-DD"),
      dateLabel: "",
      errors: {
        name: "",
      },
    };
  }

  async componentDidMount() {
    this.getSaleListData(this.state.activeTransactionKey);
  }

getSaleListData(_type) {
  let _transArray = [];
  let _paidAmt = 0;
  let _unpaidAmt = 0;
  let _totalAmt = 0;

  const requestData = JSON.stringify({
    business_id: this.state.businessId,
    company_id: this.state.company_id,
    type: _type,
    isDateFilter: true,
    start_date: this.state.startDate,
    end_date: this.state.endDate,
  });

    PostData(global.userLoanAccountReportList, requestData, "POST").then((result) => {
      const responseJson = result;
      if (!responseJson.success) {
        this.setState({
          transactionArrayFilter: [],
          itemArray: [],
          isLoaded: true,
          paidAmount: 0,
          unpaidAmount: 0,
          total: 0,
          countList: 0,
          totalTransAmt: 0,
          totalBalanceAmt: 0,
        });
      } else {
        const data = responseJson.response || [];
        data.forEach((item) => {
          _unpaidAmt += parseFloat(item.current_balance || 0);
          _paidAmt += parseFloat(item.opening_balance || 0);
          _totalAmt += parseFloat(item.opening_balance || 0);
        });

        this.setState({
          transactionArrayFilter: data,
          itemArray: data,
          isLoaded: true,
          paidAmount: _paidAmt,
          unpaidAmount: _unpaidAmt,
          total: _totalAmt,
          countList: responseJson.countList || 0,
          totalTransAmt: responseJson.totalTransAmt || 0,
          totalBalanceAmt: responseJson.totalBalanceAmt || 0,
        });
      }
    })
    .catch((error) => this.setState({ error, isLoaded: false }));
}

loadTranscListing() {
  let dataList = { columns: [], rows: [] };
  let rows = [];

  if (this.state.isLoaded) {
    const transactions = this.state.transactionArrayFilter;

    if (transactions.length > 0) {
      transactions.forEach((item, index) => {
        rows.push({
          sr_no: item.srNo || index + 1,
          date: moment(item.date_as).format("YYYY-MM-DD"),
          type: item.account_name || "-", // you can map more meaningful values if needed
          amount: numberFormat(item.opening_balance),
          ending_balance: numberFormat(item.current_balance),
        });
      });
    }
  }

  if (rows.length > 0) {
    dataList = {
      columns: columns,
      rows: rows,
    };
  }

  return dataList;
}


  handleCallBackDate = (start, end) => {
    this.setState({
      startDate: start.format("YYYY-MM-DD"),
      endDate: end.format("YYYY-MM-DD"),
    });
    this.getSaleListData();
  };


  exportData = (event) =>{
    let _itemDetails = this.state.transactionArrayFilter;
    try {
      let totalAmount = 0;
      _itemDetails.map((data) => {
        totalAmount += parseFloat(data.total_amount);
      });

      _itemDetails = _itemDetails.map((data) => {

        let newData = {
          'Date': moment(data.date_as).format("YYYY-MM-DD"),
          'Type': data.account_name || "-",
          'Amount': numberFormat(data.opening_balance),
          'Ending Balance': numberFormat(data.current_balance),
        }
         return newData;
      });
      
      let totalAmountRow = {
        'Date': '',
        'Type': '',
        'Amount': '',
        'Ending Balance': '',
      };

      _itemDetails.push({});
      _itemDetails.push(totalAmountRow);
      var ws = XLSX.utils.json_to_sheet(_itemDetails);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb,ws,"Loan Statement Report");
      const wbout = XLSX.write(wb, {type:'array', bookType:"xlsx"});
      let length = 6;
      let uniqueNo = String(Math.floor(Math.pow(10, length - 1) + Math.random() * (Math.pow(10, length) - Math.pow(10, length - 1) - 1)));
      let fileName = 'export_loan_statement_report_'+moment().format('YYYY-MM-DD')+'.xlsx';
      const data = new Blob([wbout], {type: "xlsx"});
      FileSaver.saveAs(data, fileName);

    } catch (err) {
      //alert('Unknown Error: ' + JSON.stringify(err));
      throw err;
    }
  }

  render() {
    if (this.state.isLoaded == true) {
      _loader = "glb-ldr-prt";
    }
    const { errors } = this.state;
    return (
      <React.Fragment>
        <div className="content">
          <div className="block">
            <div className="row">
              <div className="col-md-12">
                <h5># Stock Summary</h5>
                <div className="block">
                  <div className="block-content" style={{ marginTop: "-20px" }}>
                    <div className="row items-push">
                      <div className="row col-lg-12">
                        <div className="col-lg-9">
                          <span>Filter : </span>
                          <DateRangePicker
                            initialSettings={{
                              startDate: this.state.startDate,
                              endDate: this.state.endDate,
                              locale: {
                                format: "YYYY-MM-DD",
                              },
                              ranges: {
                                Today: [moment().toDate(), moment().toDate()],
                                Yesterday: [
                                  moment().subtract(1, "days").toDate(),
                                  moment().subtract(1, "days").toDate(),
                                ],
                                "This Week": [
                                  moment()
                                    .startOf("week")
                                    .format("YYYY-MM-DD"),
                                  moment().endOf("week").format("YYYY-MM-DD"),
                                ],
                                "This Month": [
                                  moment().startOf("month").toDate(),
                                  moment().endOf("month").toDate(),
                                ],
                                "Last Month": [
                                  moment()
                                    .subtract(1, "month")
                                    .startOf("month")
                                    .toDate(),
                                  moment()
                                    .subtract(1, "month")
                                    .endOf("month")
                                    .toDate(),
                                ],
                                "This Quarter": [
                                  moment().startOf("month").toDate(),
                                  moment()
                                    .add(2, "month")
                                    .endOf("month")
                                    .toDate(),
                                ],
                                "This Financial Year": [
                                  moment()
                                    .month("April")
                                    .startOf("month")
                                    .format("YYYY-MM-DD"),
                                  moment()
                                    .add(1, "year")
                                    .month("March")
                                    .endOf("month")
                                    .format("YYYY-MM-DD"),
                                ],
                              },
                            }}
                            onCallback={this.handleCallBackDate}
                          >
                            <input
                              type="text"
                              className="form-control col-7"
                              style={{ display: "inline-block" }}
                            />
                          </DateRangePicker>
                        </div>
                        <div className="col-lg-3">
                          <div className="row pb-20 pull-right">
                            <div className="text-right">
                              <div className="js-appear-enabled text-center">
                                <Link onClick={this.exportData} >
                                  <div className="text-info">
                                    <i className="fa fa-file-excel-o"></i>
                                  </div>
                                  <div className="font-size-sm text-muted">
                                        Excel Export
                                  </div>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                        <br />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="block" style={{ marginTop: "-60px" }}>
            <div className="row">
              <div className="col-md-12">
                <div className="block">
                  <div className="block-content">
                    <h2 className="block-title ml-10">Transactions</h2>
                    {/* <a href={global.webUrl+"business/add-sale/"} style={{marginTop: '35px'}} className="pull-right pull-right btn btn-sm btn-primary mb-10">
                                            <i className="fa fa-plus-circle"></i> Add Sale
                                        </a> */}
                  </div>
                  <div className="block-content" id="tableData">
                    <MDBDataTableV5
                      hover
                      entriesOptions={[25, 50, 100]}
                      entries={25}
                      pagesAmount={4}
                      span
                      pagingTop
                      searchTop
                      searchBottom={false}
                      barReverse
                      data={this.loadTranscListing()}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="global_loader" className={_loader}>
          <div className="gl-ldr-cld">
            <div className="gl-ldr-ctr">
              <div className="gl-loader"></div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
